<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs8>
                <v-card>
                    <v-progress-linear
                        v-if="studentLoading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <v-layout row v-if="!studentLoading">
                        <v-layout column class="ma-1 px-3">
                            <v-card-text class="mb-0 mt-0 pb-2">
                                <v-layout row align-center>
                                    <div class="display-1 font-weight-medium">
                                        {{ student.fullName }}
                                    </div>
                                    <v-btn
                                        flat
                                        icon
                                        class="ml-2 my-0"
                                        color="success"
                                        @click="updateStudentDialog = true"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-layout>
                                <v-divider class="mt-2 mb-4 pb-1"></v-divider>
                                <div class="ml-2 mt-2">
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-for="prop in getStudentProperties()"
                                    >
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            {{ prop.name }}:
                                        </div>
                                        <div>
                                            {{ prop.value }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-0" align-center>
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Is Gabba
                                        </div>
                                        <div v-if="!editingGabba">
                                            {{ student.isGabba ? "Yes" : "No" }}
                                        </div>
                                        <v-btn
                                            v-if="!editingGabba"
                                            @click="editGabba"
                                            flat
                                            icon
                                            class="text-xs-right my-0"
                                            color="success"
                                        >
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-checkbox
                                            v-if="editingGabba"
                                            class="my-0"
                                            hide-details
                                            label="Is Gabba"
                                            color="success"
                                            style="max-width: 120px;"
                                            v-model="isGabba"
                                        ></v-checkbox>
                                        <v-btn
                                            v-if="editingGabba"
                                            @click="rollbackEditGabba"
                                            small
                                            class="my-0"
                                            color="default"
                                            dark
                                            >Cancel</v-btn
                                        >
                                        <v-btn
                                            v-if="editingGabba"
                                            @click="saveGabba"
                                            small
                                            :loading="processing"
                                            class="my-0"
                                            color="success"
                                            >Save</v-btn
                                        >
                                    </v-layout>

                                    <v-layout row class="mb-0" align-center>
                                        <div
                                            class="font-weight-medium mr-2 width-200"
                                        >
                                            Note
                                        </div>
                                        <div v-if="!editingStudentNote">
                                            {{ student.studentNote }}
                                        </div>
                                        <v-btn
                                            v-if="!editingStudentNote"
                                            @click="editStudentNote"
                                            flat
                                            icon
                                            class="text-xs-right my-0"
                                            color="success"
                                        >
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-text-field
                                            v-if="editingStudentNote"
                                            class="my-0 mr-3"
                                            hide-details
                                            label="Student Note"
                                            color="success"
                                            style="max-width: 220px;"
                                            v-model="studentNote"
                                        ></v-text-field>
                                        <v-btn
                                            v-if="editingStudentNote"
                                            @click="rollbackEditStudentNote"
                                            small
                                            class="my-0"
                                            color="default"
                                            dark
                                            >Cancel</v-btn
                                        >
                                        <v-btn
                                            v-if="editingStudentNote"
                                            @click="saveStudentNote"
                                            small
                                            :loading="processing"
                                            class="my-0"
                                            color="success"
                                            >Save</v-btn
                                        >
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>
                </v-card>
                <transactions
                    :transactions="transactions"
                    :gifts="gifts"
                    :groupHours="groupHours"
                    :trackingDetails="trackingDetails"
                    :setup="setup"
                    :student="student"
                    :reload="load"
                    :loading="transactionsLoading"
                    :getDomain="getDomain"
                ></transactions>
            </v-flex>
            <v-flex xs4 class="pa-0">
                <v-card class="pa-3">
                    <v-progress-linear
                        v-if="studentLoading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <v-card-text v-if="!studentLoading" class="px-0">
                        <div
                            class="px-0 pb-4"
                            style="border: #5cb860 1px solid"
                        >
                            <v-layout
                                class="headline mb-4 px-2 py-2 font-weight-medium"
                                style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                                layout
                                row
                                justify-space-between
                                >Current Year: {{ setup.currentYear }}</v-layout
                            >
                            <v-layout
                                row
                                justify-space-between
                                class="pb-2 px-4"
                            >
                                <div class="heading font-weight-medium">
                                    Paid:
                                </div>
                                <div class="heading font-weight-medium">
                                    {{ student.paid | currency }}
                                </div>
                            </v-layout>
                            <v-layout
                                v-if="student.totalMissingAmount"
                                row
                                justify-space-between
                                class="pb-2 px-4"
                            >
                                <div class="heading font-weight-medium">
                                    Missing Amount:
                                </div>
                                <div
                                    class="heading font-weight-medium text-danger"
                                >
                                    ({{
                                        student.totalMissingAmount | currency
                                    }})
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                justify-space-between
                                class="pb-2 px-4"
                            >
                                <div class="heading font-weight-medium">
                                    Paid Group:
                                </div>
                                <div class="heading font-weight-medium">
                                    {{ student.paidGroup | currency }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                justify-space-between
                                class="px-4 mt-3 headline font-weight-bold"
                                style="color: #5cb860;"
                            >
                                <div>
                                    Total Paid:
                                </div>
                                <div>
                                    {{ student.totalPaid | currency }}
                                </div>
                            </v-layout>
                        </div>

                        <div
                            v-if="getOldTotals().length"
                            class="mt-5 px-0 pb-4"
                            style="border: #5cb860 1px solid"
                        >
                            <v-layout
                                class="headline mb-4 px-2 py-2 font-weight-medium"
                                style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                                layout
                                row
                                justify-space-between
                                >Past Years</v-layout
                            >
                            <div
                                v-for="(total, index) in getOldTotals()"
                                class="pt-2"
                            >
                                <v-layout
                                    row
                                    justify-space-between
                                    wrap
                                    class="pb-2 px-4"
                                >
                                    <div class="heading font-weight-medium">
                                        {{ total.year }}
                                    </div>
                                    <div class="heading font-weight-medium">
                                        {{ total.amount | currency }}
                                    </div>
                                </v-layout>
                                <v-divider
                                    class="mt-2 mb-4 pb-1"
                                    v-if="index + 1 < getOldTotals().length"
                                    :key="index"
                                ></v-divider>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog scrollable v-model="updateStudentDialog" max-width="700">
            <update-student
                v-if="updateStudentDialog"
                :student="student"
                :reloadGrid="loadStudent"
                :closeUpdateStudentDialog="closeUpdateStudentDialog"
                :getDomain="getDomain"
            ></update-student>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import {
    except,
    toTitleCase,
    formatCurrency,
    groupBy,
    sum,
} from "../../utils/helpers.js";
import Transactions from "./PurimTransactions.vue";
import UpdateStudent from "./PurimUpdateStudent.vue";

export default {
    components: {
        Transactions,
        UpdateStudent,
    },
    data() {
        return {
            student: {},
            setup: {},
            transactions: [],
            gifts: [],
            groupHours: [],
            trackingDetails: [],

            studentLoading: true,
            transactionsLoading: true,

            editingGabba: false,
            editingStudentNote: false,
            studentNote: "",
            isGabba: "",
            processing: false,
            updateStudentDialog: false,
        };
    },
    async created() {
        await this.loadSetup();
        await this.load();
    },
    computed: {},
    methods: {
        async load() {
            this.loadStudent();
            this.loadTransactions();
            this.loadGifts();
            this.loadTrackingDetails();
            this.loadGroupHours();
        },
        async loadStudent() {
            const student = await this.$http.get(
                this.getDomain() +
                    "/api/purimStudents/getByID?studentID=" +
                    this.$route.params.id,
            );

            this.studentLoading = false;

            this.student = student;

            this.isGabba = this.student.isGabba ? true : false;
        },
        async loadTransactions() {
            const transactions = await this.$http.get(
                this.getDomain() +
                    "/api/transactions/getByStudentID?studentID=" +
                    this.$route.params.id,
            );

            this.transactionsLoading = false;

            this.transactions = transactions.sort((a, b) => {
                if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                if (Date.parse(a.date) < Date.parse(b.date)) return 1;
                return 0;
            });
        },
        async loadGifts() {
            const gifts = await this.$http.get(
                this.getDomain() +
                    "/api/purimStudents/getGifts?studentID=" +
                    this.$route.params.id,
            );

            this.gifts = gifts
                .filter((g) => g.year == this.setup.currentYear)
                .sort((a, b) => {
                    if (Date.parse(a.dateEntered) > Date.parse(b.dateEntered))
                        return -1;
                    if (Date.parse(a.dateEntered) < Date.parse(b.dateEntered))
                        return 1;
                    return 0;
                });
        },
        async loadGroupHours() {
            const groupHours = await this.$http.get(
                this.getDomain() +
                    "/api/purimStudents/getGroupHours?studentID=" +
                    this.$route.params.id,
            );

            this.groupHours = groupHours
                .filter((g) => g.year == this.setup.currentYear)
                .sort((a, b) => {
                    if (Date.parse(a.enteredOn) > Date.parse(b.enteredOn))
                        return -1;
                    if (Date.parse(a.enteredOn) < Date.parse(b.enteredOn))
                        return 1;
                    return 0;
                });
        },
        async loadTrackingDetails() {
            const trackingDetails = await this.$http.get(
                this.getDomain() +
                    "/api/purimStudents/getTrackingDetails?studentID=" +
                    this.$route.params.id,
            );

            this.trackingDetails = trackingDetails
                .filter((g) => g.year == this.setup.currentYear)
                .sort((a, b) => {
                    if (Date.parse(a.enteredOn) > Date.parse(b.enteredOn))
                        return -1;
                    if (Date.parse(a.enteredOn) < Date.parse(b.enteredOn))
                        return 1;
                    return 0;
                });
        },
        async loadSetup() {
            const setup = await this.$http.get(
                this.getDomain() + "/api/setup/getSetup",
            );

            this.setup = setup;

            const giftSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getGiftSetup",
            );

            this.setup.giftSetups = giftSetups;

            const trackSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getTrackSetup",
            );

            this.setup.trackSetups = trackSetups;

            const groupSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getGroupSetup",
            );

            this.setup.groupSetups = groupSetups;
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:50346"
                : "https://purim-admin-portal.azurewebsites.net";
        },
        getOldTotals() {
            const oldTransactions = this.transactions.filter(
                (t) => t.year != this.setup.currentYear,
            );

            const group = groupBy(oldTransactions, "year");

            return Object.keys(group).map((key) => {
                const transactions = group[key];

                return {
                    year: key,
                    amount: sum(transactions.map((t) => t.amount)),
                };
            });
        },
        closeUpdateStudentDialog() {
            this.updateStudentDialog = false;
        },
        editGabba() {
            this.editingGabba = true;
        },
        rollbackEditGabba() {
            this.editingGabba = false;

            this.isGabba = this.student.isGabba ? true : false;
        },
        async saveGabba() {
            const student = JSON.parse(JSON.stringify(this.student));

            try {
                this.processing = true;

                student.isGabba = this.isGabba;

                await this.$http.post(
                    this.getDomain() + "/api/purimStudents/updateStudent",
                    student,
                );

                this.editingGabba = false;
                this.processing = false;

                this.loadStudent();
            } catch (e) {
                this.processing = false;
            }
        },
        editStudentNote() {
            this.studentNote = this.student.studentNote;

            this.editingStudentNote = true;
        },
        rollbackEditStudentNote() {
            this.editingStudentNote = false;
        },
        async saveStudentNote() {
            const student = JSON.parse(JSON.stringify(this.student));

            try {
                this.processing = true;

                student.note = this.studentNote;

                await this.$http.post(
                    this.getDomain() +
                        "/api/purimStudents/saveStudentNote?studentID=" +
                        student.studentID +
                        "&note=" +
                        student.note,
                );

                this.editingStudentNote = false;
                this.processing = false;

                this.loadStudent();
            } catch (e) {
                this.processing = false;
            }
        },
        getStudentProperties() {
            return Object.keys(
                except(
                    this.student,
                    "fname",
                    "laname",
                    "fullName",
                    "totalPaid",
                    "beforePurimAmount",
                    "totalMissingAmount",
                    "paid",
                    "paidGroup",
                    "track1",
                    "track1",
                    "track2",
                    "track3",
                    "track4",
                    "track5",
                    "track6",
                    "track7",
                    "track8",
                    "track9",
                    "isGabba",
                    "notes",
                ),
            )
                .map((key) => {
                    let name = toTitleCase(key);

                    name = name.endsWith("ID")
                        ? name
                        : name.replace(/([A-Z])/g, " $1").trim();

                    const value = ["isActive"].includes(key)
                        ? this.student[key]
                            ? "Yes"
                            : "No"
                        : this.student[key];

                    return {
                        name,
                        value,
                    };
                })
                .filter((p) => p.value);
        },
    },
};
</script>
